import React from 'react';
// material ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Grid,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
// zustand
import { create } from "zustand"
import moment from "moment";
import { RowDetail, RowBase, } from "../../components";

const useConfirmDialogStore = create((set) => ({
  auditoria: null,
  onSubmit: undefined,
  close: () => set({ onSubmit: undefined }),
}));

export const auditoriaDialog = (auditoria, onSubmit) => {
  useConfirmDialogStore.setState({
    auditoria,
    onSubmit,
  });
};

const AuditoriaDialog = () => {
  const { auditoria, onSubmit, close } = useConfirmDialogStore();
  return (
    <Dialog open={Boolean(onSubmit)} onClose={close} maxWidth={'xs'} fullWidth>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <DialogTitle>Auditoria del registro</DialogTitle>
        <IconButton onClick={close}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <RowBase>
          <Grid item xs={1}>
            <RowDetail r1={6} r2={6} nombre={'Usuario creación'} valor={auditoria?.createdBy} />
            <RowDetail r1={6} r2={6} nombre={'Fecha creación'} valor={moment(auditoria?.createdDate).format("YYYY-MM-DD")} />
            <RowDetail r1={6} r2={6} nombre={'Actualizado por'} valor={auditoria?.modifiedBy} />
            <RowDetail r1={6} r2={6} nombre={'Fecha actualización'} valor={moment(auditoria?.modifiedDate).format("YYYY-MM-DD")} />
          </Grid>
        </RowBase>
      </DialogContent>

    </Dialog>
  );
};

export default AuditoriaDialog;